<template>
  <!-- 特卖评价 -->
  <div class="sale_evalute">
    <div class="sale_eva_main">
      <!-- 评价 -->
      <div class="sale_eva_title">
        <!-- 标题 -->
        <h3>
          <p></p>评价
        </h3>
        <!-- 星 -->
        <p>***************************************************************************************************************************************************************************************************************************************************************</p>
      </div>
      <!-- 全部评价 -->
      <div class="sale_eva_all">
        <!-- 好评度 -->
        <div class="sale_eva_degree">
          <div>
            <span>好评度</span>
            <span>
              <p>90</p>
              <p>%</p>
            </span>
          </div>
        </div>
        <!-- 评价选项 -->
        <div class="sale_eva_option">
          <p
            v-for="item in saleList"
            :key="item.index"
            :class="{sale_color:isColor == item.index}"
            @click="changeColor(item.index)"
          >{{item.name}}</p>
        </div>
      </div>
      <!-- 评价详情导航栏 -->
      <div class="sale_eva_detail">
        <!-- 导航栏 -->
        <div class="sale_det_nav">
          <p
            v-for="item in saleNavList"
            :key="item.index"
            :class="{color:navColor == item.index}"
            @click="changeNavColor(item.index)"
          >{{item.name}}</p>
        </div>
        <!-- 详情 -->
        <div class="sale_det_concrete">
          <div class="sale_concrete_top">
            <div class="sale_concrete_l">
              <span>
                <img src="../../assets/img/bicon26.png" alt />
                <p>甄惠装粉丝~</p>
              </span>
            </div>
            <!-- 评价内容 -->
            <div class="sale_concrete_r">
              <!-- 评分 -->
              <el-rate v-model="value" :colors="['#F56C6C', '#F56C6C', '#F56C6C']" :disabled="true"></el-rate>
              <!-- 评价文字 -->
              <p>原来家里就买了一个，那会觉得就挺好看的，样子简单大方，上档次，用了一年效果也不错，朋友来家里都夸好看也好用这次给朋友家里也买了一个，价格还是那么实惠，安装师傅也来的很快，装上这，卫生间都变得好看了好多，很满意的一次购物。</p>
              <!-- 评价时间 -->
              <i>2019-04-09</i>
              <div class="conmment_delete">删除</div>
            </div>
          </div>
          <!-- 晒图评价 -->
          <div class="sale_concrete_top">
            <div class="sale_concrete_l">
              <span>
                <img src="../../assets/img/bicon26.png" alt />
                <p>甄惠装粉丝~</p>
              </span>
            </div>
            <!-- 评价内容 -->
            <div class="sale_concrete_r">
              <!-- 评分 -->
              <el-rate v-model="value" :colors="['#F56C6C', '#F56C6C', '#F56C6C']" :disabled="true"></el-rate>
              <!-- 评价文字 -->
              <p>原来家里就买了一个，那会觉得就挺好看的，样子简单大方，上档次，用了一年效果也不错，朋友来家里都夸好看也好用这次给朋友家里也买了一个，价格还是那么实惠，安装师傅也来的很快，装上这，卫生间都变得好看了好多，很满意的一次购物。</p>
              <!-- 晒图 -->
              <div>
                <img src="../../assets/img/bicon28.png" alt />
              </div>
              <!-- 评价时间 -->
              <i>2019-04-09</i>
              <div class="conmment_delete">删除</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { productPinglun, keysWord } from "../../api/api";

export default {
  name: "sale-evalute",
  props: {
    goodsId: ""
  },
  data() {
    return {
      goodsId: "",
      value: 3,
      // 评价选项颜色
      isColor: 1,
      saleList: [
        { index: 1, name: "毫不掉色（41）" },
        { index: 2, name: "尺寸（1578）" },
        { index: 3, name: "毫不掉色（4）" },
        { index: 4, name: "毫不掉色（23）" },
        { index: 5, name: "毫不掉色（6）" },
        { index: 6, name: "尺寸（1578）" },
        { index: 7, name: "毫不掉色（4）" },
        { index: 8, name: "尺寸（1578）" },
        { index: 9, name: "毫不掉色（4）" },
        { index: 10, name: "毫不掉色（4）" }
      ],
      // 评价详情导航栏
      navColor: 1,
      saleNavList: [
        { index: 1, name: "全部评价（5.7万+）" },
        { index: 2, name: "晒图（260）" },
        { index: 3, name: "好评（1689）" },
        { index: 4, name: "差评（147）" }
      ],
      pageSize: 10,
      pageIndex: 1,
      keyList: []
    };
  },

  methods: {
    changeColor(index) {
      this.isColor = index;
    },
    changeNavColor(index) {
      this.navColor = index;
      console.log(this.navColor);
    },
    // getKeyWords() {
    //   let params = {
    //     goodsId: this.goodsId
    //   };
    //   keysWord(params).then(res => {
    //     console.log(res);
    //     let data = res.ResultObj;
    //     console.log(data);
    //   });
    // },
    // getAjustify() {
    //   let paramas = {
    //     goodsId: this.goodsId,
    //     pageIndex: this.pageIndex,
    //     pageSize: this.pageSize,
    //     key: ""
    //   };
    //   productPinglun(paramas).then(res => {
    //     console.log(res);
    //   });
    // }
    //查询商品评论
    getgoodcomment() {
      let that = this;
      var addParams = {
        keyWord: "",
        goodsId: that.goodsId,
        pageIndex: that.copageIndex,
        pageSize: that.copageSize
      };
      productPinglun(addParams).then(data => {
        this.total = data.ResultObj;
      });
    },
    //获取关键字统计
    getkeyword() {
      let that = this;
      console.log("234892348", that.goodsId);
      var addParams = {
        goodsId: this.goodsId
      };
      keysWord(addParams).then(data => {
        data = data.ResultObj;
      });
    }
  },
  created() {
    // console.log(1);
    // console.log(this.goodsId);
    // this.getgoodcomment();
    // this.getkeyword();
  },
  watch: {
    goodsId(newValue, oldVale) {
      console.log(this.goodsId);
      // this.getKeyWords();
      // this.getAjustify();
      // this.getgoodcomment();
      this.getkeyword();
    }
  }
};
</script>
<style scoped>
.sale_evalute {
  /* width: 1200px; */
  background: #fff;
  margin-left: 20px;
}
.sale_eva_main {
  /* width: 1200px; */
  margin: 0 auto;
}
/* 评价 */
.sale_eva_main .sale_eva_title {
  /* height: 410px; */
  margin-top: 25px;
}
/* 评价标题 */
.sale_eva_title h3 {
  color: #333;
  text-align: left;
  font-size: 22px;
  margin-bottom: 10px;
  font-weight: normal;
}
.sale_eva_title h3 p {
  display: inline-block;
  width: 4px;
  height: 21px;
  background: rgba(222, 7, 22, 1);
  margin: 0 10px -4px 0;
}
/* 星 */
.sale_eva_title p {
  color: rgba(237, 237, 237, 1);
  margin: 0;
}
/* 全部评价 */
.sale_eva_all {
  height: 144px;
}
/* 好评度 */
.sale_eva_all .sale_eva_degree {
  float: left;
  width: 85px;
  height: 80px;
  text-align: left;
  margin: 15px 0 0 15px;
}
/*  */
.sale_eva_degree span {
  font-size: 14px;
  width: 100%;
  display: inline-block;
  font-family: MicrosoftYaHei-Bold;
  font-weight: bold;
  color: rgba(85, 85, 85, 1);
  margin-bottom: 10px;
  float: left;
}
/* 百分比 */
.sale_eva_degree span p {
  color: rgba(222, 7, 22, 1);
  font-size: 14px;
  float: left;
  line-height: 28px;
  margin: 0;
}
.sale_eva_degree span p:first-child {
  font-size: 28px;
}
/* 评价选项卡 */
.sale_eva_all .sale_eva_option {
  width: 1050px;
  height: 80px;
  font-size: 14px;
 
  font-weight: 400;
  color: rgba(136, 136, 136, 1);
  margin-top: 30px;
}
/* 文字 */
.sale_eva_all .sale_eva_option p {
  width: 114px;
  height: 35px;
  line-height: 35px;
  text-align: center;
  display: inline-block;
  border: 1px solid rgba(237, 237, 237, 1);
  margin: 0 10px 10px 0;
  cursor: pointer;
}
/* 评价详情 */
/* 导航栏 */
.sale_eva_main .sale_eva_detail .sale_det_nav {
  /* width: 1200px; */
  height: 46px;
  background: rgba(248, 248, 248, 1);
  margin-bottom: 22px;
  line-height: 46px;
}
.sale_eva_detail .sale_det_nav p {
  float: left;
  margin: 0 35px 0 16px;
  color: rgba(85, 85, 85, 1);
  font-size: 12px;
  cursor: pointer;
}
/* 评价选项颜色 */
.sale_color {
  border-color: rgba(222, 7, 22, 1) !important;
  color: rgba(222, 7, 22, 1) !important;
}
/* 评价详情导航栏颜色 */
.color {
  color: rgba(222, 7, 22, 1) !important;
}
/* 评价详情 */
.sale_eva_main .sale_eva_detail .sale_det_concrete .sale_concrete_top {
  overflow: hidden;
  margin-bottom: 20px;
}
/* 左侧评价人 */
.sale_det_concrete .sale_concrete_l {
  width: 170px;
  height: 166px;
  float: left;
  text-align: left;
  line-height: 40px;
}
.el-rate__icon {
  margin-right: 0 !important;
}
/* 头像 */
.sale_concrete_l span img {
  float: left;
}
/* 甄惠装粉丝 */
.sale_concrete_l span p {
  float: left;
  font-size: 14px;
  color: rgba(136, 136, 136, 1);
  margin: 0 0 0 10px;
}
/* 右侧评价内容 */
.sale_det_concrete .sale_concrete_r {
  padding-right: 20px;
  margin-left: 170px;
  text-align: left;
  border-bottom: 1px solid rgba(237, 237, 237, 1);
  position: relative;
  width: auto;
  box-sizing: border-box;
}
/* 删除按钮 */
.conmment_delete {
  position: absolute;
  top: 0;
  right: 27px;
  width: 60px;
  height: 30px;
  background-color: #6786b4;
  border-radius: 3px;
  line-height: 30px;
  text-align: center;
  font-size: 14px;
  color: #fff;
  cursor: pointer;
}
/* 评分 */
/* 评价文字 */
.sale_concrete_r p {
  font-size: 12px;
  color: rgba(51, 51, 51, 1);
  line-height: 20px;
  margin-top: 23px;
}
/* 晒图 */
.sale_concrete_r div {
  /* margin-top:30px */
}
/* 评价时间 */
.sale_concrete_r i {
  display: inline-block;
  font-size: 12px;
  color: rgba(136, 136, 136, 1);
  margin: 34px 0;
}
</style>





// WEBPACK FOOTER //
// saleEvalute.vue?3a5d6d06